import React, { useEffect, useState } from 'react';
import "../styles/globals.css";
import { getMarketplaceToken } from "../api/marketplaceAuth";


function ChevronDown({ open }) {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      aria-hidden="true"
      style={{ transform: `rotate(${open ? 180 : 0}deg)` }}
    >
      <path
        d="M2 3.5L5 6.5L8 3.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function TopBanner() {
  const [servicesOpen, setServicesOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(Boolean(getMarketplaceToken()));

  useEffect(() => {
    const syncLoginState = () => setIsLoggedIn(Boolean(getMarketplaceToken()));
    syncLoginState();
    window.addEventListener("storage", syncLoginState);
    return () => window.removeEventListener("storage", syncLoginState);
  }, []);

  return (
    
      <div className="top-banner">
        <ul className="top-banner-left">
          <li><a href="/buying">For Buyers</a></li>
          <li><a href="/selling">For Sellers</a></li>
          <li
            className="dropdown-banner"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            Services <ChevronDown open={servicesOpen} />
            {servicesOpen && (
              <div className="services-dropdown">
                <ul>
                  <li><a href="https://mycarapp.co.ke/inventory">Vehicle Marketplace</a></li>
                  <li><a href="https://mycarapp.co.ke/breakdown-response">Breakdown Response</a></li>
                  <li><a href="https://garage.mycarapp.co.ke/">Garage Management</a></li>
                    <li><a href="https://mycarapp.co.ke/car-hire">Car Hire</a></li>
                  <li><a href="https://mycarapp.co.ke/accessories-spares">Accessories & Spares</a></li>
                </ul>
              </div>
            )}
          </li>
        </ul>
        <div className="top-banner-right">
          <p>Call us: +254 700 000 000 </p>
          {!isLoggedIn && <div>
            <a href="/login" className="flex justify-center gap-2 items-center">
               <i className="fa-regular fa-user"></i>
            <p>Login</p>
            </a>
          </div>}
        </div>
      </div>
    
  );
}
